import { parse } from 'date-fns';
import { isValidDate } from './isValidDate';

const FORMATS = ['MM/dd/yy', 'M/dd/yy', 'M/dd', 'MM/dd', 'M/d', 'MM/d', 'M'];
export const parseDate = (str: string, format: string): Date | null => {
  let parsedDate: Date | null = null;
  if (!str.length) {
    return null;
  }

  parsedDate = parse(str, format, new Date());
  if (!isValidDate(parsedDate)) {
    for (let i = 0; i < FORMATS.length; i++) {
      parsedDate = parse(str, FORMATS[i], new Date());
      if (isValidDate(parsedDate)) {
        return parsedDate;
      }
    }

    if (!isValidDate(parsedDate)) {
      const newDate = new Date(str);
      parsedDate = isValidDate(newDate) ? newDate : parsedDate;
    }
  }
  return parsedDate;
};
